import { render, staticRenderFns } from "./newTour.vue?vue&type=template&id=7813e77d&"
import script from "./newTour.vue?vue&type=script&lang=js&"
export * from "./newTour.vue?vue&type=script&lang=js&"
import style0 from "./newTour.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports